import React, { useEffect } from 'react';
import styles from './styles/NotificacaoSucesso.module.css';

const NotificacaoSucesso = ({ show, message = "Produto adicionado com sucesso", onClose }) => {
    // Fecha com ESC + trava o scroll do body
    useEffect(() => {
        if (!show) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose?.();
        };

        document.addEventListener('keydown', handleKeyDown);

        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = originalOverflow;
        };
    }, [show, onClose]);

    if (!show) return null;

    return (
        <div
            className={styles.backdrop}
            role="dialog"
            aria-modal="true"
            aria-label="Confirmação"
            onClick={onClose} // clique no fundo fecha
        >
            <div
                className={styles.modal}
                onClick={(e) => e.stopPropagation()} // evita fechar ao clicar dentro
            >
                <div className={styles.iconWrap}>
                    <div className={styles.checkIcon}>✓</div>
                </div>

                <h2 className={styles.titulo}>{message}</h2>
                {/* <p className={styles.subtitulo}>Seu item já está na sacola.</p> */}

                <br />

                <button className={styles.btnOk} onClick={onClose} autoFocus>
                    OK
                </button>
            </div>
        </div>
    );
};

export default NotificacaoSucesso;